/**
 * Whether a game update brings coins to toss on the board, and how: its own flips (made by the move that produced
 * this version), not tossed already. The player's own wait for their tap; the opponent's toss by themselves. A flip
 * is the mover's unless it names someone else (a sleeping Pokémon's owner flips for it between turns).
 *
 * @returns {{ version: number, flips: object[], waitForTap: boolean }|null}
 */
export function tossFor(game, { userId, seenVersion }) {
  const coinFlips = game.coin_flips;
  if (!coinFlips || !coinFlips.flips || !coinFlips.flips.length || coinFlips.version !== game.version) {
    return null;
  }
  if (seenVersion !== null && coinFlips.version <= seenVersion) {
    return null;
  }
  const mine = coinFlips.flips.every(flip => (flip.user_id !== undefined ? flip.user_id : coinFlips.user_id) === userId);
  return { version: coinFlips.version, flips: coinFlips.flips, waitForTap: mine };
}
